import React from 'react';
import propTypes from 'prop-types';

const Typography = ({ variant, className, alignment, weight, children }) => {
	const HTMLTag = `${variant}`;
	const classes = [];
	classes.push(className);
	classes.push(alignment ? `text-${alignment}` : null);
	classes.push(weight ? `font-weight-${weight}` : null);

	return (
		<HTMLTag className={`${variant} ${classes.join(' ')}`}>
			{children}
		</HTMLTag>
	);
};

export default Typography;

Typography.defaultProps = {
	alignment: '',
	weight: '',
	className: ''
};

export const TypographyProps = {
	variant: propTypes.string.isRequired,
	alignment: propTypes.string,
	weight: propTypes.string,
	className: propTypes.string,
	children: propTypes.oneOfType([propTypes.string, propTypes.shape({})])
		.isRequired
};

Typography.propTypes = TypographyProps;
